import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import { mapCreatorConnect } from '../../higher-order-components';
import { MapCreatorMarkerTypeSelector } from 'components';
import { emit } from 'utils';

class MarkerEditorIconModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      current_marker_icon: null
    };

    this.handleSelectMarker = this.handleSelectMarker.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  handleSelectMarker(marker) {
    this.setState({ current_marker_icon: marker });
  }
  handleSave() {
    const { current_feature, current_map } = this.props.mapCreator;
    const updated_props = { ...current_feature.properties, icon_file: this.state.current_marker_icon.file_data._id };
    this.props.updateCurrentMapFeature({ ...current_feature, properties: updated_props }, current_map._id);
  }
  componentDidUpdate(prev_props) {
    const prev_show = prev_props.mapCreator.show_marker_editor_icon_modal;
    const { show_marker_editor_icon_modal: curr_show, current_feature } = this.props.mapCreator;
    if(prev_show == false && curr_show == true) {
      this.setState({ current_marker_icon: current_feature.properties.icon });
    }
  }

  render() {
    const {
      current_feature,
      show_marker_editor_icon_modal
     } = this.props.mapCreator;
    return show_marker_editor_icon_modal ? (
      <Modal
        show={show_marker_editor_icon_modal}
        onHide={() => this.props.toggleShowMarkerEditorIconModal(false)}
        bsSize='small'
        >
        <Modal.Header>Choose Marker Icon</Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12} xs={12}>
              <MapCreatorMarkerTypeSelector
                handleSelectMarker={this.handleSelectMarker}
                selected_marker_icon={this.state.current_marker_icon}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={6} md={6}>
              <Button block onClick={() => this.props.toggleShowMarkerEditorIconModal(false)}>Cancel</Button>
            </Col>
            <Col xs={6} md={6}>
              <Button block bsStyle='primary' onClick={this.handleSave}>Save</Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    ) : null;
  }
}

export default mapCreatorConnect(MarkerEditorIconModal);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/marker-editor-icon-modal.js